import * as THREE from 'three'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Resources from './Utils/Resources.js'
import Debug from './Utils/Debug.js'
import sources from './sources.js'
import Stats from 'stats.js'
import Overlay from "./Overlay.js"
import HandTracking from './XR-mode/HandTracking.js'
import HitTesting from './XR-mode/HitTesting.js'
import XRRig from './XR-mode/XRRig.js'

let instance = null

export default class Experience {
    constructor(canvas) {

        // Singleton
        if(instance) return instance
        instance = this

        // GLobal access
        window.experience = this

        // Options
        this.canvas = canvas

        // Setup
        this.debug = new Debug()
        this.stats = new Stats()
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.worldGroup = new THREE.Group()
        this.scene.add(this.worldGroup)

        this.xrRig = new THREE.Group()
        this.xrRig.name = 'xrTrackingRig'
        this.worldGroup.add(this.xrRig)

        this.overlay = new Overlay()
        this.resources = new Resources(sources, this.overlay.loadingManager)
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.handTracking = new HandTracking()
        this.hitTesting = new HitTesting()
        this.xrRigController = new XRRig(this)
        this.world = new World()

        // Sizes resize event
        this.sizes.on('resize', () => {
            this.resize()
        })

        // Time tick event - triggered by renderer's setAnimationLoop
        this.time.on('tick', () => {
            this.update()
        })
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.camera.update()
        this.handTracking.update()
        // Pass XR frame to hit testing (set by renderer's animation loop)
        this.hitTesting.update(this.xrFrame)
        this.xrRigController.update()
        this.world.update()
        this.renderer.update()
    }

    destroy() {
        this.sizes.off('resize')
        this.time.off('tick')

        // Traverse the whole scene
        this.scene.traverse(child => {
            if (child instanceof THREE.Mesh) {
                child.geometry.dispose()
                for (const key in child.material) {
                    const value = child.material[key]

                    if (value && typeof value.dispose === 'function') {
                        value.dispose()
                    }
                }
            }
        })

        this.camera.controls.dispose()
        this.renderer.instance.dispose()
        // this.EffectComposer.dispose()

        if (this.debug.active) this.debug.ui.destroy()
    }
}